function isPreventTime(diffTime, to = 1200){
    return (new Date().getTime() - diffTime) < to;
}

export  default  isPreventTime;


// WEBPACK FOOTER //
// ./history/2017/171206_flamedragon/_src/js/component/isPreventTime.js